import { render, staticRenderFns } from "./EditDepartment.vue?vue&type=template&id=53992216"
import script from "./EditDepartment.vue?vue&type=script&lang=js"
export * from "./EditDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports